import { companyGeneralFields, companyOtherInfoFields, companyProfileFields } from '../../common/forms/company/fields'
import { contactDetailSearchFields, contactGeneralFields, contactOtherInfoFields, contactProfileFields } from '../../common/forms/contacts/fields'
import responseFields from '../../common/constants/responseFields'
import { ContactType } from '../globalTypes'

export const CONTACT_VALUE_ENDPOINTS = {
    companySize: 'v1/contact/values/contactCompanySize',
    coreBusiness: 'v1/contact/values/contactCoreBusiness',
    definition: 'v1/contact/values/contactDefinition',
    companyDefinition: 'v1/contact/values/companyDefinition',
    description: 'v1/contact/values/contactDescription',
    emailType: 'v1/contact/values/contactEmailType',
    gender: 'v1/contact/values/contactGender',
    jobTitle: 'v1/contact/values/contactJobTitle',
    legalForm: 'v1/contact/values/contactLegalForm',
    maritalStatus: 'v1/contact/values/contactMaritalStatus',
    phoneType: 'v1/contact/values/contactPhoneType',
    priority: 'v1/contact/values/contactPriority',
    queryCategory: 'v1/contact/values/contactQueryCategory',
    status: 'v1/contact/values/contactStatus',
    title: 'v1/contact/values/contactTitle',
    financing: 'v1/contact/values/contactFinancing',
    profileDuration: 'v1/contact/values/contactProfileDuration',
    profileStatus: 'v1/contact/values/contactProfileStatus',
    profileRemark: 'v1/contact/values/contactProfileRemark',
    profileService: 'v1/contact/values/contactProfileService',
    country: 'v1/contact/values/contactCountry',
    propertyType: 'v1/property/values/propertyType',
    propertySubtype: 'v1/property/values/propertySubType',
    floor: 'v1/property/values/propertyFloor',
    dataSource: 'v1/property/values/dataSource',
} as const

export const ENDPOINT_FILTERS: Record<string, string[]> = {
    propertySubtype: ['propertyType'],
    floor: ['propertyType'],
}

// Contact/Company General form field mappings
export const getGeneralFieldsConfig = (contactType: ContactType) => {
    const fields = contactType === ContactType.Person ? contactGeneralFields : companyGeneralFields

    const baseConfig = {
        priority: fields.CONTACT_PRIORITY_ID,
        status: fields.CONTACT_STATUS_ID,
        phoneType: fields.CONTACT_PHONE_TYPE_ID,
        emailType: fields.CONTACT_EMAIL_TYPE_ID,
        country: fields.CONTACT_COUNTRY_ID,
        queryCategory: fields.CONTACT_QUERY_CATEGORY_ID,
    }

    if (contactType === ContactType.Person) {
        return {
            ...baseConfig,
            title: contactGeneralFields.CONTACT_TITLE_ID,
        }
    }

    return {
        ...baseConfig,
        legalForm: companyGeneralFields.CONTACT_LEGAL_FORM_ID,
    }
}

// Contact/Company Profile form field mappings
export const getProfileFieldsConfig = (contactType: ContactType) => {
    const baseConfig = {
        profileService: contactProfileFields.CONTACT_PROFILE_SERVICE_ID,
        profileStatus: contactProfileFields.CONTACT_PROFILE_STATUS_ID,
        financing: contactProfileFields.CONTACT_FINANCING_ID,
        profileDuration: contactProfileFields.CONTACT_PROFILE_DURATION_ID,
    }

    if (contactType === ContactType.Person) {
        return {
            ...baseConfig,
            definition: contactProfileFields.CONTACT_DEFINITION_ID,
        }
    }

    return {
        ...baseConfig,
        companyDefinition: companyProfileFields.COMPANY_DEFINITION_ID,
    }
}

// Contact Other Info form field mappings
export const contactOtherInfoFieldsConfig = {
    description: contactOtherInfoFields.CONTACT_DESCRIPTION_ID,
    gender: contactOtherInfoFields.CONTACT_GENDER_ID,
    jobTitle: contactOtherInfoFields.CONTACT_JOB_TITLE_ID,
    maritalStatus: contactOtherInfoFields.CONTACT_MARTIAL_STATUS_ID,
    country: contactOtherInfoFields.BIRTH_COUNTRY_ID,
}

// Company Other Info form field mappings
export const companyOtherInfoFieldsConfig = {
    coreBusiness: companyOtherInfoFields.CONTACT_CORE_BUSINESS_ID,
    companySize: companyOtherInfoFields.CONTACT_COMPANY_SIZE_ID,
}

// Contact Detail Search form field mappings
export const contactDetailSearchFieldsConfig = {
    profileService: contactDetailSearchFields.CONTACT_PROFILE_SERVICE,
    profileStatus: contactDetailSearchFields.CONTACT_PROFILE_STATUS,
    country: contactDetailSearchFields.CONTACT_COUNTRY,
    queryCategory: contactDetailSearchFields.CONTACT_QUERY_CATEGORY,
    priority: contactDetailSearchFields.CONTACT_PRIORITY,
    status: contactDetailSearchFields.CONTACT_STATUS,
    dataSource: contactDetailSearchFields.DATA_SOURCE,
}

// Contact/Company Profile Detail Search (profileSelectOptions) form field mappings
export const contactProfileDetailSearchFieldsConfig = {
    propertyType: responseFields.PROPERTY_TYPE,
    propertySubtype: responseFields.PROPERTY_SUB_TYPE,
    profileDuration: responseFields.CONTACT_PROFILE_DURATION,
    floor: responseFields.PROPERTY_FLOOR,
}
